import VideoSlide from './video'
export default VideoSlide
